<script lang="ts">
  import { onMount } from "svelte"
  import { xhr, toast } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import ValueInline from "$app/Pages/Plans/Onboarding/components/ValueInline.svelte"
  import Navigation from "./Navigation.svelte"
  import { Loader } from "lucide-svelte"
  import bg from "@images/onboarding/bg-eclipse.jpg"
  import img from "@images/onboarding/values.png"
  import { onboardingStore } from "./onboarding.svelte"
  import { appStore } from "$app/store.svelte"
  import PrevNextSkipButtons from "$app/Pages/Plans/Onboarding/components/PrevNextSkipButtons.svelte"

  onboardingStore.saving = false
  onboardingStore.completed = true

  let values: StatementType[] = $state([])
  let validValues: boolean[] = $state([])

  let activeIndex: number = $state(0)
  let loading = $state(false)

  async function getValues(): Promise<void> {
    try {
      loading = true
      const resp = await xhr.get(
        `/plan_onboarding/${appStore.plan.id}/get_statements.json?statement_type=values`
      )

      values = resp.data
    } catch (e) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error loading the values", "error")
    } finally {
      loading = false
    }
  }

  let errors: any = $state({})

  getValues()

  onMount(() => {
    onboardingStore.setBrowserHistory({}, "values")
  })
</script>

<div class="mx-auto px-2 lg:px-6 pt-4 w-full pb-8 lg:pb-20 lg:text-left">
  <div class="px-4 w-full">
    <Navigation step="values" on:updateStep />
  </div>
  <div class="px-4 w-full lg:w-1/2 xl:pr-16">
    <h2 class="mt-12 text-5xl font-bold text-left text-white">
      What Are Your Values?
    </h2>

    <p class="mt-8 text-white text-lg max-w-lg">
      These are the principles you want your company to live by. We recommend
      entering your top 5 values.
    </p>

    <div class="mt-8 max-w-lg">
      <div class="flex items-center gap-2 text-white" class:hidden={!loading}>
        <div>
          <Loader class="rotate" size="1.3rem" />
        </div>
        <div>Loading values</div>
      </div>

      {#each values as val, idx}
        <div class="flex w-full" data-name="line-{idx + 1}">
          <div class="border-b border-gray-500 w-full">
            <ValueInline
              statement={val}
              index={idx + 1}
              active={idx === activeIndex}
              onactive={() => (activeIndex = idx)}
              onprocess={(data) => {
                validValues[idx] = data
              }}
            />
          </div>
        </div>
      {/each}
    </div>

    <PrevNextSkipButtons />
  </div>
</div>
<div
  class="relative w-full hidden lg:inline lg:absolute lg:inset-y-32 lg:-mb-32 rounded-tl-lg lg:-right-0 md:w-1/3 lg:w-1/2 lg:h-full bg-lwp-light-grey bg-right-bottom bg-no-repeat bg-contain"
  style="background-image: url({bg})"
>
  <img
    src={img}
    alt="Values"
    class="absolute shadow-lg rounded border border-gray-500 inset-y-4 inset-x-6 xl:-inset-x-6 w-11/12 object-fill"
  />
</div>
